import React from "react";
import Layout from "../../components/layout";
import FaQ from "../../components/patient-information/faq";
import SEO from "../../components/seo";

const FaQPage = () => (
  <Layout>
    <SEO title="Frequently Asked Questions" />
    <FaQ />
  </Layout>
);

export default FaQPage;
